import { InstituitionService } from "@/lib/Institutions";
import StringUtils from "@/utils/StringUtils";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import useCurrentUser from "./useCurrentUser";


// export default function useInstitution(institutionId: string) {
//   if(!institutionId) {
//     return {
//       data: null,
//       isLoading: false,
//       isError: false,
//       error: null,
//     };
//   }

//   return useQuery({
//     queryKey: ['institution', institutionId],
//     queryFn: () => InstituitionService.getIntitutionById(institutionId as string),
//     staleTime: 10 * 60 * 1000,
//     select(data) {
//       return {
//         ...data,
//         name: StringUtils.capitalizePhrase(data?.name as string),
//       }
//     }
//   });
// }

// Regular hook for optional institutionId
export default function useInstitution(id: string = "") {
  const { data: user } = useCurrentUser();
  const institutionId = user?.account?.studentStatus?.institutions?.[0] ?? id;

  return useQuery({
    queryKey: ['institution', institutionId],
    queryFn: () => InstituitionService.getIntitutionById(institutionId as string),
    enabled: !!institutionId,
    staleTime: 10 * 60 * 1000,
    select(data) {
      return {
        ...data,
        name: StringUtils.capitalizePhrase(data?.name as string),
      }
    }
  });
}

// Suspense version - always calls the hook (no conditional returns)
export function useInstitutionSuspense(institutionId: string) {
  // Always call the hook - no conditional returns/throws before it
  const result = useSuspenseQuery({
    queryKey: ['institution', institutionId || '__placeholder__'],
    queryFn: async () => {
      if (!institutionId) {
        // Return a default/null value instead of throwing
        return null;
      }
      return InstituitionService.getIntitutionById(institutionId);
    },
    staleTime: 10 * 60 * 1000,
    select(data) {
      if (!data) return null;
      return {
        ...data,
        name: StringUtils.capitalizePhrase(data?.name as string),
      }
    }
  });

  return {
    data: result.data,
    isLoading: false,
    isError: false,
    error: null,
  };
}